import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const eventos = {
	state: {
		eventos: null
	},
	getters: {
		getEventos: state => state.eventos,
		categoriaEventos: (state) => {

			let eventos = state.eventos;

			if (!!eventos) {

				let categorias = new Array();

				eventos.forEach(evento => {
					if (!categorias.some(c => c.slug == evento.categoria.slug)) {
						categorias.push(evento.categoria)
					}
				});

				return categorias;
			}
		},
		getEventosFiltrados: state => {

			return (filtro) => {

				let searchIn = ['titulo', 'entradilla']

				let eventos = state.eventos;

				let filtradas;

				if (!!eventos) {

					filtradas = eventos.filter(evento => {

						let can = false;

						searchIn.forEach(where => {
							(evento[where].toLowerCase().includes(filtro.search.toLowerCase())) ? can = true : '';
						});

						return (can) ? evento : '';
					});

					filtradas = filtradas.filter(evento => evento.categoria.slug.includes(filtro.categoria));
				}

				return filtradas;

			}
		},
	},
	actions: {
		requestEventos: ({ commit },) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/Alumno/dameEventos`)
					.then(response => {
						commit('setEventos', response.data.datos);
						resolve(true);
					})
					.catch(error => reject(error));

			});
		},
		requestEvento: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/Alumno/dameFichaEvento/${slug}`)
					.then(response => {
						resolve(response.data.datos);
					})
					.catch(err => reject(error));

			});
		},
		requestEventoPublico: ({ commit }, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/Publico/dameFichaEvento/${slug}`)
					.then(response => {
						resolve(response.data.datos);
					})
					.catch(err => reject(error));

			});
		},
		requestInscripcion: ({ commit }, id) => {

			let data = {"idEvento": id, "urlEvento" : ""}

			return new Promise((resolve, reject) => {

				axios.post(`/api/Alumno/inscribirseEnEvento`, data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 533);
						resolve(true);
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}
				}).catch(error => {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});

			});
		}
	},
	mutations: {
		setEventos: (state, eventos) => {
			eventos = eventos.sort((a, b) => {
				let adate = new Date(a.fecha).getTime();
				let bdate = new Date(b.fecha).getTime();
				
				return (bdate - adate)
			  });
			state.eventos = eventos;
		}
	}
}

export default eventos;



// WEBPACK FOOTER //
// ./submodules/dotia-base-fp/src/store/eventos.js